var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.loading || _vm.loadingCreate,"opacity":"0.99"}},[_c('v-data-table',{staticClass:"v-data-table-forms-semiology",attrs:{"headers":_vm.headers,"items":_vm.semiology_forms,"search":_vm.search,"footer-props":{
        'items-per-page-options': [50, 75, 100],
        'items-per-page-text': 'Mostrar',
      }},on:{"click:row":_vm.clickRowTable}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }